import React from 'react';
import CrudLayoutContainer from 'src/components/crud-layout-component/CrudLayoutContainer';
import { DATE_TIME_FORMAT } from 'src/constants/CommonConstants';
import PermissionHOC from 'src/hoc/PermissionHOC';
import { UnAuthorizedErrorPage } from 'src/utils/CommonUtils';
import RoutingUtil from 'src/utils/RoutingUtil';
import SearchContainerWithPermission from '../search-container/SearchContainerWithPermission';
import { areaEditAction, areaSearchAction } from './actions/AreaActions';
import AreaForm from './AreaForm';

const tabs = [
    {
        title: 'Manage',
        link: RoutingUtil.areaManagerUrl(),
    },
    {
        title: 'Search',
        link: RoutingUtil.areaSearch(),
    },
];

const routes = [
    {
        link: RoutingUtil.areaManagerUrl(),
        component: () => (
            <PermissionHOC
                scope="master.area_manager.manage"
                fallback={<UnAuthorizedErrorPage />}
                component={<AreaForm />}
            />
        ),
    },
    {
        link: RoutingUtil.areaSearch(),
        component: () => (
            <SearchContainerWithPermission
                scope="master.area_manager.search"
                editScope="master.area_manager.search.edit"
                fallback={<UnAuthorizedErrorPage />}
                reducer="AreaReducer"
                dataPath="search"
                editAction={areaEditAction}
                redirectUrlOnEdit={RoutingUtil.areaManagerUrl()}
                action={areaSearchAction}
                columns={{
                    areaName: {
                        display: 'Area Name',
                    },
                    areaType: {
                        display: 'Area Type',
                    },
                    lat: {
                        display: 'Lat',
                    },
                    lng: {
                        display: 'Lng',
                    },
                    pincode: {
                        display: 'Pincode',
                    },
                    stateId: {
                        display: 'State',
                        path: 'stateName',
                    },
                    by: {
                        display: 'By',
                        path: 'by.personalInfo.firstName',
                    },
                    updatedBy: {
                        display: 'Updated By',
                        path: 'updatedBy.personalInfo.firstName',
                    },
                    ts: {
                        display: 'Ts',
                        type: Date,
                        format: DATE_TIME_FORMAT.TIMEAGO,
                    },
                    updatedTs: {
                        display: 'Updated Ts',
                        type: Date,
                        format: DATE_TIME_FORMAT.TIMEAGO,
                    },
                }}
            />
        ),
    },
];

const AreaContainer = () => (
    <CrudLayoutContainer
        title="Area Manager"
        tabs={tabs}
        routes={routes}
    />
);

AreaContainer.propTypes = {
};

export default AreaContainer;
